import { faBan, faUserGear } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Button, Form } from '@domain-group/suit-theme'

import { confirmDelete } from '@functions/entity'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import type { UseCampaignPortalModalPayload } from '@modals/EditCampaignPortalModal/hooks/useCampaignPortalModal'

interface MoreOptionsProps {
  campaignPortalModalPayload: UseCampaignPortalModalPayload,
  callbacks: {
    closeModal: () => void,
    updateAgency: (params: HandleCallbackActionParams) => void,
  },
}

const MoreOptions = (props: MoreOptionsProps) => {
  const {
    campaignPortalModalPayload,
    callbacks: {
      closeModal,
    },
  } = props

  const {
    agency,
    callbacks: {
      deleteCampaignPortal,
    },
    campaignPortalFormPayload,
    portal,
  } = campaignPortalModalPayload

  const { setEntityState } = campaignPortalFormPayload

  // @ts-expect-error
  const defaultEnabledOptionValues = agency?.options?.enabled_portal_option_values?.[portal?.short_code] || []
  // @ts-expect-error
  const hiddenOptionValues = agency?.options?.disabled_portal_option_values?.[portal?.short_code] || []

  const filteredDefaultOptionValues = defaultEnabledOptionValues.filter(
    (value: number) => !hiddenOptionValues.includes(value),
  )

  const confirmDeletePayload = {
    callbacks: {
      action: deleteCampaignPortal,
      afterAction: closeModal,
    },
    strings: {
      confirmString: 'Are you sure? Data will no longer be pushed to the portal.',
      deleteString: 'disable',
      entityName: 'Campaign Portal',
    },
  }

  return (
    <Form>
      <Form.Field label="More Options" marginTop="large">
        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faUserGear} />}
          onClick={() => setEntityState({ enabled_portal_option_values: filteredDefaultOptionValues })}
          size="medium"
        >
          Use Defaults
        </Button>

        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faBan} />}
          loadingBubbleColor="white"
          // @ts-expect-error
          marginTop="medium"
          // @ts-expect-error TS2345
          onClick={() => confirmDelete(confirmDeletePayload)}
          size="medium"
        >
          Disable Portal
        </Button>
      </Form.Field>
    </Form>
  )
}

export default MoreOptions
